import request from '@/utils/request.js'

export const configuration = (params) => request.post("/api/golive/configuration", params);
export const check_captions = (params) => request.post("/api/golive/check_captions", params);
export const get_lead = (params) => request.post("/api/golive/get_lead", params);


